module.exports = __webpack_public_path__ + "img/10979911_L.960be4c7.png";